import { render, staticRenderFns } from "./PortafolioBusqueda.vue?vue&type=template&id=39f87c22&scoped=true"
import script from "./PortafolioBusqueda.vue?vue&type=script&lang=js"
export * from "./PortafolioBusqueda.vue?vue&type=script&lang=js"
import style0 from "./PortafolioBusqueda.vue?vue&type=style&index=0&id=39f87c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f87c22",
  null
  
)

export default component.exports